// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const directoryConfigSchema = z.object({
  "kind": z.enum(["scim", "ldap", "google_workspace"]),
  "enabled": z.boolean(),
  "sync_interval_minutes": z.number().int().min(5),
  "identity_source_id": z.string().uuid().nullable(),
  "base_url": z.string().optional(),
  "include_groups": z.boolean().optional(),
  "deactivate_on_remove": z.boolean().optional(),
  "host": z.string().optional(),
  "port": z.number().int().min(1).optional(),
  "use_tls": z.boolean().optional(),
  "bind_dn": z.string().optional(),
  "user_search_base": z.string().optional(),
  "user_filter": z.string().optional(),
  "attr_email": z.string().optional(),
  "attr_display_name": z.string().optional(),
  "admin_email": z.string().optional(),
  "customer_id": z.string().optional(),
  "include_suspended": z.boolean().optional()
}).strict();

export const directoryStatusSchema = z.object({
  "kind": z.enum(["scim", "ldap", "google_workspace", "none"]),
  "enabled": z.boolean(),
  "last_run": z.unknown().refine((value) => [z.object({
    "id": z.string().uuid(),
    "started_at": z.string().datetime({ offset: true }),
    "finished_at": z.string().datetime({ offset: true }).nullable(),
    "status": z.enum(["pending", "running", "success", "partial", "failed"]),
    "users_created": z.number().int().min(0),
    "users_updated": z.number().int().min(0),
    "users_deactivated": z.number().int().min(0),
    "error": z.string().nullable(),
    "failure_count": z.number().int().min(0),
    "failures": z.array(z.object({
      "external_id": z.string(),
      "reason": z.string()
    }).strict()).max(20)
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "id": z.string().uuid(),
    "started_at": z.string().datetime({ offset: true }),
    "finished_at": z.string().datetime({ offset: true }).nullable(),
    "status": z.enum(["pending", "running", "success", "partial", "failed"]),
    "users_created": z.number().int().min(0),
    "users_updated": z.number().int().min(0),
    "users_deactivated": z.number().int().min(0),
    "error": z.string().nullable(),
    "failure_count": z.number().int().min(0),
    "failures": z.array(z.object({
      "external_id": z.string(),
      "reason": z.string()
    }).strict()).max(20)
  }).strict(), z.null()])),
  "next_run_at": z.string().datetime({ offset: true }).nullable()
}).strict();

export const directoryOverviewSchema = z.object({
  "status": directoryStatusSchema,
  "config": z.unknown().refine((value) => [directoryConfigSchema, z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([directoryConfigSchema, z.null()]))
}).strict();

export const adInboundDirectorySchema = z.object({
  "id": z.string().uuid(),
  "name": z.string(),
  "directory_type": z.enum(["ad", "entra", "google_workspace", "scim", "workday", "github", "veza", "pureauth"]),
  "sync_direction": z.enum(["inbound", "outbound", "bidirectional"]),
  "delivery": z.enum(["agent", "server"]),
  "group_membership_mode": z.enum(["disabled", "add_only", "directory_managed", "authoritative"]),
  "enabled": z.boolean(),
  "sync_status": z.enum(["active", "inactive", "error"]),
  "sync_status_message": z.string().nullable(),
  "sync_interval_seconds": z.number().int().min(1),
  "full_sync_interval_seconds": z.number().int().min(0),
  "user_external_unique_attribute": z.string(),
  "attribute_mapping": z.record(z.string(), z.string()),
  "auto_assign_users": z.boolean(),
  "auto_assign_groups": z.boolean(),
  "directory_settings": z.object({
    "ldap_path": z.string(),
    "full_sync": z.boolean(),
    "user_organizational_units": z.array(z.string()),
    "group_organizational_units": z.array(z.string())
  }).strict(),
  "oauth_application": z.object({
    "client_id": z.string(),
    "client_secret": z.string().optional()
  }).strict(),
  "last_full_sync_at": z.string().datetime({ offset: true }).nullable(),
  "last_incremental_sync_at": z.string().datetime({ offset: true }).nullable(),
  "owner_admin_id": z.string().uuid().optional(),
  "identity_source_id": z.string().uuid().nullable(),
  "created_at": z.string().datetime({ offset: true }),
  "updated_at": z.string().datetime({ offset: true })
}).strict();

export const adInboundDirectoryPaginationSchema = z.object({
  "total": z.number().int().min(0),
  "offset": z.number().int(),
  "limit": z.number().int().min(1)
}).strict();

export const adInboundDirectoriesListResponseSchema = z.object({
  "data": z.array(adInboundDirectorySchema),
  "pagination": adInboundDirectoryPaginationSchema
}).strict();

export const adOuEntrySchema = z.object({
  "path": z.string(),
  "name": z.string(),
  "parent_path": z.string().nullable()
}).strict();

export const adOuListResponseSchema = z.object({
  "ous": z.array(adOuEntrySchema),
  "synced_at": z.string().datetime({ offset: true }).nullable()
}).strict();

export const adDirectoryUserLinkSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "sync_status": z.enum(["pending", "success", "failed", "in_progress"]),
  "retry_count": z.number().int().min(0),
  "external_id": z.string().nullable(),
  "synced_at": z.string().datetime({ offset: true }).nullable(),
  "sync_message": z.string().nullable(),
  "display_name": z.string().nullable(),
  "primary_email": z.string().nullable(),
  "user_status": z.enum(["active", "suspended", "deactivated", "deleted"]).nullable()
}).strict();

export const adDirectoryUsersResponseSchema = z.object({
  "data": z.array(adDirectoryUserLinkSchema),
  "pagination": adInboundDirectoryPaginationSchema
}).strict();

export const adDirectoryGroupLinkSchema = z.object({
  "id": z.string().uuid(),
  "group_id": z.string().uuid(),
  "sync_status": z.enum(["pending", "success", "failed", "in_progress"]),
  "retry_count": z.number().int().min(0),
  "external_id": z.string().nullable(),
  "ad_group_scope": z.string().nullable(),
  "ad_group_type": z.string().nullable(),
  "ou_path": z.string().nullable(),
  "synced_at": z.string().datetime({ offset: true }).nullable(),
  "sync_message": z.string().nullable(),
  "display_name": z.string().nullable(),
  "member_count": z.number().int().min(0).nullable(),
  "members_synced_at": z.string().datetime({ offset: true }).nullable(),
  "members_sync_status": z.enum(["success", "partial", "failed", "skipped"]).nullable(),
  "members_sync_message": z.string().nullable()
}).strict();

export const adDirectoryGroupsResponseSchema = z.object({
  "data": z.array(adDirectoryGroupLinkSchema),
  "pagination": adInboundDirectoryPaginationSchema
}).strict();

export const directorySyncRejectSchema = z.object({
  "id": z.string().uuid(),
  "object_type": z.enum(["user", "group"]),
  "source_key": z.string(),
  "reason_code": z.enum(["missing_unique_attribute", "unsupported_unique_attribute", "ambiguous_match", "user_create_failed", "group_create_failed", "invalid_payload", "adoption_requires_review"]),
  "message": z.string().nullable(),
  "payload": z.record(z.string(), z.unknown()),
  "occurrences": z.number().int().min(1),
  "first_seen_at": z.string().datetime({ offset: true }),
  "last_seen_at": z.string().datetime({ offset: true })
}).strict();

export const directorySyncRejectsResponseSchema = z.object({
  "data": z.array(directorySyncRejectSchema),
  "pagination": adInboundDirectoryPaginationSchema
}).strict();

export const identitySourceSchema = z.object({
  "id": z.string().uuid(),
  "name": z.string(),
  "kind": z.enum(["entra", "okta", "ping", "google", "authentik", "generic"]),
  "record_ownership": z.enum(["upstream", "pureid"]),
  "status": z.enum(["active", "disabled"]),
  "provider_id": z.string().uuid().nullable(),
  "active_token_id": z.string().uuid().nullable(),
  "token_count": z.number().int().min(0),
  "people_count": z.number().int().min(0),
  "created_at": z.string().datetime({ offset: true }),
  "updated_at": z.string().datetime({ offset: true })
}).strict();

export const identitySourceListSchema = z.object({
  "data": z.array(identitySourceSchema)
}).strict();
